export const SET_SCROLL_TO_TOP = 'SET_SCROLL_TO_TOP';
export const setScrollToTop = value => ({
  type: SET_SCROLL_TO_TOP,
  value: value
});
